import { render } from "./Btn.vue?vue&type=template&id=25624380&scoped=true"
import script from "./Btn.vue?vue&type=script&setup=true&lang=js"
export * from "./Btn.vue?vue&type=script&setup=true&lang=js"

import "./Btn.vue?vue&type=style&index=0&id=25624380&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25624380"],['__file',"src/js/components/Btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25624380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25624380', __exports__)) {
    api.reload('25624380', __exports__)
  }
  
  module.hot.accept("./Btn.vue?vue&type=template&id=25624380&scoped=true", () => {
    api.rerender('25624380', render)
  })

}


export default __exports__